import Store from '../interfaces/Store';
import { Action, ActionType } from './actions';
import { moveSelectedArticleOnLineSlotReducer } from './configuration/articles/move/moveArticleOnLineSlot.reducers';
import { moveArticleOnSingleSlotReducer } from './configuration/articles/move/moveArticleOnSingleSlot.reducers';
import { updateArticleColorReducer } from './configuration/articles/updateColor/updateArticleColor.reducers';
import { loadConfigurationReducer } from './configuration/load/loadConfiguration.reducers';
import { replaceConfigurationReducer } from './configuration/replace/replaceConfiguration.reducers';
import { resetConfigurationReducer } from './configuration/reset/resetConfiguration.reducers';
import { setConfigurationRightsReducer } from './configuration/rights/configurationRights.reducers';
import { setSelectedArticleReducer } from './selection/selection.reducers';
import {
  disableInteractionsReducer,
  enableInteractionsReducer,
} from './suppressInteractions/suppressInteractions.reducers';
import {
  addNotificationsReducer,
  removeNotificationReducer,
} from './notifications/notifications.reducers';
import { setConfigurationCodeReducer } from './configuration/configurationCode/setConfigurationCode.reducers';
import { setDimensionsReducer } from './configuration/dimensions/dimensions.reducers';
import { moveHeightControlPanelReducer } from './configuration/articles/move/moveHeightControlPanel.reducers';
import { loadAnonymousConfigurationReducer } from './configuration/loadAnonymous/loadAnonymousConfiguration.reducers';
import { setThemeReducer } from './configuration/articles/setTheme/setTheme.reducers';

export const INITIAL_STATE: Store = Store.empty();

const configuratorReducer = (state: Store = INITIAL_STATE, action: Action): Store => {
  switch (action.type) {
    case ActionType.ADD_ARTICLE:
      return replaceConfigurationReducer(state, action.payload);
    case ActionType.REMOVE_ARTICLE:
      return replaceConfigurationReducer(state, action.payload);
    case ActionType.REPLACE_ARTICLE:
      return replaceConfigurationReducer(state, action.payload);
    case ActionType.REPLACE_REQUIRED_ARTICLE:
      return replaceConfigurationReducer(state, action.payload);
    case ActionType.RESET_CONFIGURATION:
      return resetConfigurationReducer(state);
    case ActionType.LOAD_CONFIGURATION:
      return loadConfigurationReducer(state, action.payload);
    case ActionType.LOAD_ANONYMOUS_CONFIGURATION:
      return loadAnonymousConfigurationReducer(state, action.payload);
    case ActionType.UPDATE_ARTICLE_COLOR:
      return updateArticleColorReducer(state, action.payload);
    case ActionType.DISABLE_INTERACTIONS:
      return disableInteractionsReducer(state, action.payload);
    case ActionType.ENABLE_INTERACTIONS:
      return enableInteractionsReducer(state, action.payload);
    case ActionType.SELECT_ARTICLE:
      return setSelectedArticleReducer(state, action.payload);
    case ActionType.ADD_NOTIFICATIONS:
      return addNotificationsReducer(state, action.payload);
    case ActionType.REMOVE_NOTIFICATION:
      return removeNotificationReducer(state, action.payload);
    case ActionType.MOVE_ARTICLE_ON_SINGLE_SLOT:
      return moveArticleOnSingleSlotReducer(state, action.payload);
    case ActionType.SET_CONFIGURATION_RIGHTS:
      return setConfigurationRightsReducer(state, action.payload);
    case ActionType.MOVE_ARTICLE_ON_LINE_SLOT:
      return moveSelectedArticleOnLineSlotReducer(state, action.payload);
    case ActionType.MOVE_HEIGHT_CONTROL_PANEL:
      return moveHeightControlPanelReducer(state, action.payload);
    case ActionType.SET_CONFIGURATION_CODE:
      return setConfigurationCodeReducer(state, action.payload);
    case ActionType.SET_DIMENSIONS:
      return setDimensionsReducer(state, action.payload);
    case ActionType.SET_THEME:
      return setThemeReducer(state, action.payload);
    default:
      return state;
  }
};

export default configuratorReducer;
